import React from 'react';
import {
  FiSearch,
  FormProvider,
  SelectField,
  TextField,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { CompanyContactInformationSerializer } from '@bcba/serializers';
import { useContactInfoSection } from './hooks/useContactInfoSection';
import { SectionGrid } from '../../SectionGrid';

interface Props {
  data: CompanyContactInformationSerializer;
}

export const ContactForm = (props: Props) => {
  const { data } = props;
  const { t } = useTranslation();

  const {
    handleSubmit,
    onSubmit,
    formMethods,
    provinces,
    localities,
    defaultProvinceInputValue,
    isLoadingLocalities,
    actionButtons,
  } = useContactInfoSection({ defaultValues: data });

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <FormProvider {...formMethods}>
        <SectionGrid>
          <TextField
            name="street"
            label={t('common.street')}
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
          />
          <TextField
            name="streetNumber"
            label={t('common.number')}
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
          />
          <SelectField
            label={t('common.province')}
            options={provinces ?? []}
            name="provinceUuid"
            rhfOptions={{ required: true }}
            errorMessageFormatter={t}
            defaultInputValue={defaultProvinceInputValue}
            leftIcon={FiSearch}
          />

          <SelectField
            label={t('common.locality')}
            options={localities ?? []}
            name="localityUuid"
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
            value={localities}
            debounce={500}
            noOptionMessage={t('businessSignUp.form.locality.noOptions')}
            isLoading={isLoadingLocalities}
            isDisabled={!localities}
          />
          <TextField
            name="postalCode"
            label={t('common.postalCode')}
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
            type="number"
          />
          <TextField
            name="phoneNumber"
            label={t('common.phone')}
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
            type="number"
          />
          <TextField
            name="email"
            label={t('common.email')}
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
            type="email"
          />
          <TextField
            name="website"
            label={t('common.web')}
            errorMessageFormatter={t}
            type="url"
          />
        </SectionGrid>
        {actionButtons}
      </FormProvider>
    </form>
  );
};

export default ContactForm;
